export enum CareerServices {
  PERSONAL_BRANDING = 'Personal Branding',
  JOB_SEARCH_STRATEGY = 'Job Search Strategy',
  CAREER_TRANSITION = 'Career Transition',
  INTERVIEW_PREP = 'Interview Prep',
  SALARY_NEGOTIATION = 'Salary Negotiation',
  WORKPLACE_CHALLENGES = 'Workplace Challenges',
}
